import React, { useState } from 'react'
import Navbar from '../Navbar/Navbar';
import Fade from 'react-reveal/Fade';
import { NewSlider } from '../NewSlider/NewSlider';
import "./Contact.scss"
import Marquee from "react-fast-marquee";
import Footer from '../Footer/Footer';



export default function Contact() {
  

const [name,setName]=useState("")

const [lastname,setLastname]=useState("")
const [email,setEmail]=useState("")
const [number,setNumber]=useState("")
const [mesg,setMesg]=useState("")

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  }
  const slides = [
    {
      city: 'Paris',
      country: 'France',
      img: 'https://s3-us-west-2.amazonaws.com/s.cdpn.io/142996/paris.jpg',
    },
    {
      city: 'Singapore',
      img: 'https://s3-us-west-2.amazonaws.com/s.cdpn.io/142996/singapore.jpg',
    },
    {
      city: 'Prague',
      country: 'Czech Republic',
      img: 'https://s3-us-west-2.amazonaws.com/s.cdpn.io/142996/prague.jpg',
    },
    {
      city: 'Amsterdam',
      country: 'Netherlands',
      img: 'https://s3-us-west-2.amazonaws.com/s.cdpn.io/142996/amsterdam.jpg',
    },
    {
      city: 'Moscow',
      country: 'Russia',
      img: 'https://s3-us-west-2.amazonaws.com/s.cdpn.io/142996/moscow.jpg',
    },
  ];
  return (
    <div>
       <Navbar/>
        <NewSlider slides={slides}/>

        <Marquee className='marquee' speed={100}>
        <img src='https://e7.pngegg.com/pngimages/833/991/png-clipart-logo-forbes-industry-magazine-black-cover-company-text.png' alt=''/>
        <img src='https://e7.pngegg.com/pngimages/833/991/png-clipart-logo-forbes-industry-magazine-black-cover-company-text.png' alt=''/>
        <img src='https://e7.pngegg.com/pngimages/833/991/png-clipart-logo-forbes-industry-magazine-black-cover-company-text.png' alt=''/>
        <img src='https://e7.pngegg.com/pngimages/833/991/png-clipart-logo-forbes-industry-magazine-black-cover-company-text.png' alt=''/>
        <img src='https://e7.pngegg.com/pngimages/833/991/png-clipart-logo-forbes-industry-magazine-black-cover-company-text.png' alt=''/>        <img src='https://e7.pngegg.com/pngimages/833/991/png-clipart-logo-forbes-industry-magazine-black-cover-company-text.png' alt=''/>
      </Marquee>
      <div className='queries-slide'>
        
        <div>
          <img src='https://k82bd48pgck19i7321xvcc91-wpengine.netdna-ssl.com/wp-content/uploads/2020/07/contact-section-02-press-media.png' alt=''/>
           <div className='queries-slide-inner'>
            <div  className='queries-slide-title'>TITLE</div>
            <div  className='queries-slide-btn'>
              GET ENQUIRY

            </div>
           </div>
        </div>
        <div>
          <img src='https://k82bd48pgck19i7321xvcc91-wpengine.netdna-ssl.com/wp-content/uploads/2020/07/contact-section-02-press-media.png' alt=''/>
          <div className='queries-slide-inner'>
            <div  className='queries-slide-title'>TITLE</div>
            <div  className='queries-slide-btn'>
              GET ENQUIRY

            </div>
           </div>
        </div>
        <div>
          <img src='https://k82bd48pgck19i7321xvcc91-wpengine.netdna-ssl.com/wp-content/uploads/2020/07/contact-section-02-press-media.png' alt=''/>
          <div className='queries-slide-inner'>
            <div  className='queries-slide-title'>TITLE</div>
            <div  className='queries-slide-btn'>
              GET ENQUIRY

            </div>
           </div>
        </div>
        <div>
          <img src='https://k82bd48pgck19i7321xvcc91-wpengine.netdna-ssl.com/wp-content/uploads/2020/07/contact-section-02-press-media.png' alt=''/>
          <div className='queries-slide-inner'>
            <div  className='queries-slide-title'>TITLE</div>
            <div  className='queries-slide-btn'>
              GET ENQUIRY

            </div>
           </div>
       </div>
        <div>
          <img src='https://k82bd48pgck19i7321xvcc91-wpengine.netdna-ssl.com/wp-content/uploads/2020/07/contact-section-02-press-media.png' alt=''/>
          <div className='queries-slide-inner'>
            <div  className='queries-slide-title'>TITLE</div>
            <div  className='queries-slide-btn'>
              GET ENQUIRY

            </div>
           </div>
        </div>
      </div>
      <div className="contain">

  <div className="wrapper">

    <div className="form">
      <div>
      <div className='contact-title'>
      For General Inquires and customer support, drop us a line below
so we can connect you with the right person.
            </div>

      </div>
      <div>
      <input type="text" value={name} placeholder="FIRSTNAME" required onChange={(e)=>setName(e.target.value)}/>
      <input type="text" placeholder="LASTNAME" value={lastname} onChange={(e)=>setLastname(e.target.value)} />

      </div>
      <div>
      <input type="email" placeholder="EMAIL" value={email} required  onChange={(e)=>setEmail(e.target.value)}/>
      <input type="text" placeholder="PHONE NUMBER" value={number} required  onChange={(e)=>setNumber(e.target.value)}/>

      </div>
      <div>
       



      <input className='textarea' name='message' wrap="hard" value={mesg} type="textarea" placeholder="MESSAGE"  onChange={(e)=>setMesg(e.target.value)}/>

  

      </div>
    
      
      
    </div>
   


  </div>
</div>
<div>
        <button className='contact-btn'>CONTACT THE ORGANIZATION</button>
      </div>
<Footer/>
    </div>
  )
}
